export const initialise = () => {    
    if (!document.body.classList.contains('bio')) return
    repositionLinkedInLink()
}

const repositionLinkedInLink = () => {
    const link = document.querySelector<HTMLAnchorElement>('.attrax-social-hub-profile-widget__linkedin-link')
    const container = document.querySelector<HTMLElement>('.attrax-user-profile-contact-buttons-widget__buttons')
    if (!link || !container) return

    container.appendChild(link)
}
